module.exports = __webpack_public_path__ + "47a4fa82befe601ec16f730d2768e0a0.pdf";